/**
 * Auto-categorize, as a quiet link at the bottom left of an Uncategorized list — the only place it
 * is useful, so the only place it shows.
 */
export function CategorizeLink({ onClick, pending }: { onClick: () => void; pending?: boolean }) {
  return (
    <div className='flex'>
      <button
        type='button'
        onClick={onClick}
        disabled={pending}
        title='File everything here under the category it is about'
        className='text-xs text-gray-900 underline-offset-2 hover:text-foreground hover:underline disabled:no-underline disabled:opacity-60'
      >
        {pending ? 'Categorizing…' : 'Auto-categorize these'}
      </button>
    </div>
  );
}
